const DEFAULT_PROPERTY_FALLBACK = 'https://fotos.sobressai.com.br/Fotos/imovel_sem_foto.jpg';
const DEFAULT_PROPERTY_BASE = 'https://fotos.sobressai.com.br';

export const getSafeImageSrc = (
  value: unknown,
  fallback: string = DEFAULT_PROPERTY_FALLBACK
): string => {
  const raw = String(value || '').trim();
  if (!raw) return fallback;

  const withProtocol = raw.startsWith('//') ? `https:${raw}` : raw;

  try {
    const parsed = new URL(withProtocol);
    if (!['http:', 'https:'].includes(parsed.protocol)) return fallback;
    if (parsed.protocol === 'http:') {
      parsed.protocol = 'https:';
    }
    return parsed.toString();
  } catch {
    if (withProtocol.startsWith('/')) {
      return `${DEFAULT_PROPERTY_BASE}${withProtocol}`;
    }
    return fallback;
  }
};

// Fotos legadas (fotos.sobressai.com.br) têm variantes _m (média ~540px) e _g (grande
// ~1080px). No DESKTOP, sobe a fonte pra _g pra o next/image ter resolução em tela grande
// (a _m capava o card em ~540px = foto borrada no PC); no mobile mantém _m (leve/perf).
// Se a _g não existir, o onError do card cai no fallback. Só mexe em URLs ...{id}_m.{ext}.
export const preferGrandePhoto = (value: unknown, useGrande: boolean): unknown => {
  if (!useGrande || typeof value !== 'string') return value;
  return value.replace(/_m(\.(?:jpe?g|png|webp))(\?|$)/i, '_g$1$2');
};

export const PROPERTY_IMAGE_FALLBACK = DEFAULT_PROPERTY_FALLBACK;
